import { styled } from '@mui/material';
import clsx from 'clsx';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';

import { IReadOnlyInputFieldProps, VARIANT } from './types';

import styles from './ReadOnlyInputField.module.scss';

import scssVariables from 'styles/sass-variables.module.scss';

const StyledInput = styled((props: IReadOnlyInputFieldProps) => <NumberInputControlled {...props} />)(({ look }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
    color: look === VARIANT.SUCCESS ? scssVariables.green_default : scssVariables.black,
  },
  fieldset: {
    border: `1px solid ${look === VARIANT.SUCCESS ? scssVariables.green_default : scssVariables.greys_border}`,
  },
}));

export const ReadOnlyInputField: React.FC<IReadOnlyInputFieldProps> = ({ disabled, className, ...restProps }) => {
  return (
    <StyledInput
      {...restProps}
      disabled={disabled}
      className={clsx(styles.summaryTextfield, { [styles.disabled]: disabled }, className)}
      allowNegative={true}
    />
  );
};
